import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import LayoutPage from "../../../templates/Layout/LayoutPage";
import {simpleFetch, valueFormatted, nameValidation, buildOnLoad, fetchData} from "../../../utils/helpsers";
import ParallelChart from "../../../components/organisms/ParallelChart/ParallelChart";
import Button from "@mui/material/Button";
import Grid from '@mui/material/Grid';
import DataGridTable from "../../../components/organisms/Table/DataGridTable";
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import ReportButtons from "../../../components/organisms/BugReport/ReportButtons";
import BoardBuilder from "../../../components/organisms/BoardBuilder/BoardBuilder";
import useQuery from "../../../utils/userLocation";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { Autocomplete } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from "@mui/material/Alert";
import { TokenContext } from "../../../utils/Context";
import MultiVariableFilter from '../../../components/organisms/MultiVariableFilter/MultiVariableFilter';
import Box from "@mui/material/Box";
import { DataFiltersStyles, InputEditStyles, MenuBoxStyles, SnackbarStyles } from "../DistrictInsight/DistrictInsight.styles";
import { CustomGroupStyles } from "./CustomGroupEditor.styles";
import GroupDisplay from "../../../components/molecules/GroupDisplay/GroupDisplay";

function CustomGroupEditor() {
  // User session token
  const { userToken } = useContext(TokenContext);

  const [referenceDistrict, setReferenceDistrict] = useState();
  // Data variables set on every filter.
  const [filters, setFilters] = useState();
  // Custom ranges.
  const customGroupData = useRef({
    name: null,
    description: null,
    vars: {
      var1: { varName: null, values: null },
    }
  });

  // User session metadata and data
  const { user } = useAuth0();
  const metadata = user[`${process.env.REACT_APP_AUTH0_KEY}/district`];
  const enabledShare = metadata.enable_share;
  const enabledHealthBenefits = metadata.enable_hbenefits;

  const navigate = useNavigate();
  const query = useQuery();

  // Districts counter
  const [districtsCount, setDistrictsCount] = useState();

  // Parallel chart data
  const [parallelData, setParallelData] = useState();
  const [rangeData, setRangeData] = useState();
  // Table Data
  const [gridTableData, setGridTableData] = useState();
  
  const handleFilter = () => {
    setBtnFilter(null);
  };

  // Message response on save group.
  const [postResponse, setPostResponse] = useState(null);

  const [displayResponseMessage, setDisplayResponseMessage] = React.useState(false);

  const [boardData, setBoardData] = useState();
  const [existingGroup, setExistingGroup] = useState();

  const [year, setYear] = useState();
  const [groupInfo, setGroupInfo] = useState();
  const [irns, setIrns] = useState();

  const [activeUser, setActiveUser] = useState([]);
  const [users, setUsers] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [usersFormat, setUsersFormat] = useState([]);
  const [shareWith, setShareWith] = useState([]);
  const [savedGroups, setSavedGroups] = useState();

  const [btnFilter, setBtnFilter] = useState(null);
  const [btnSaved, setBtnSaved] = useState(null);
  const [btnShared, setBtnShared] = useState(null);

  const openFilters = Boolean(btnFilter);
  const openSaved = Boolean(btnSaved);
  const openShared = Boolean(btnShared);

  const [action, setAction] = useState();

  const groupName = useRef('');
  const groupDescription = useRef('');

  const clickFilters = (event) => {
    setBtnFilter(event.currentTarget);
  };

  const closeFilters = () => {
    setBtnFilter(null);
  };

  const clickSaved = (event) => {
    setBtnSaved(event.currentTarget);
  };

  const closeSaved = () => {
    setBtnSaved(null);
  };

  const clickShared = (event) => {
    setBtnShared(event.currentTarget);
  };

  const closeShared = () => {
    setBtnShared(null);
  };

  // Get all groups created by the current user.
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/custom_groups?created_by=eq.${user.email}`, {
      headers: {
        'ngrok-skip-browser-warning': true
      }
    }).then((res) => {
      setSavedGroups(res.data);
    });
  }, [user.email])

  const handleSubmit = (event) => {
    event.preventDefault();

    let irns =
      customGroupData.current.vars[
        `var${Object.keys(customGroupData.current.vars).length
        }`
      ].irns;

    // Check if the group name is already in use
    const isNameValid = nameValidation({
      arr: savedGroups,
      key: 'label',
      name: groupName.current,
    });

    if (isNameValid) {
      axios.post(`${process.env.REACT_APP_API_URL}/custom_groups`, {
        label: groupName.current,
        description: groupDescription.current,
        irns: irns,
        custom_ranges: customGroupData.current.vars,
        reference_irn: referenceDistrict,
        year: year,
        available_users_share: shareWith,
        created_by: user.email,
      }, {
        headers: {
          'Prefer': 'return=representation',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      }).then((response) => {
        setDisplayResponseMessage(true);
        setPostResponse({
          status: "success",
          statusText: "The New Group was successfully saved"
        });
        setTimeout(() => navigate(`?shared=${response.data[0].uuid}`), 1000);
      }).catch((error) => {
        setDisplayResponseMessage(true);
        setPostResponse({
          status: "error",
          statusText: error.message
        });
      });
      setBtnSaved(null);
    } else {
      // Show an error message indicating that the group name is already in use
      setDisplayResponseMessage(true);
      setPostResponse({
        status: "error",
        statusText: "Group name is already in use"
      });
      closeShared();
    }
  };

  const getFiltersInformation = (filtersData) => {
    customGroupData.current.vars = filtersData.current.vars;
    // Update filters state for cross-year highlighting logic
    setFilters(filtersData.current.vars);

    let var1 = filtersData.current.vars.var1;
    let var2 = filtersData.current.vars.var2;
    let var3 = filtersData.current.vars.var3;
    let var4 = filtersData.current.vars.var4;
    let var5 = filtersData.current.vars.var5;
    let var6 = filtersData.current.vars.var6;

    let lastFilter = Object.keys(filtersData.current.vars).pop();
    // Updating district count with last filter value
    setDistrictsCount(filtersData.current.vars[lastFilter].districtsCount);
    // Year form filters data
    let filteredYear = filtersData.current.year
    // District IRN's required for Grid Table endpoint.
    let filteredIrns = filtersData.current.vars[lastFilter].irns;

    /** TODO Remove if validation and varName key once the saved groups structure is updated */
    let query;
    if (filtersData.current.vars[lastFilter].hasOwnProperty('varName')) {
      let range = var1.range ? 'range' : 'values';
      query = `${filtersData.current.referenceDistrict.value}&_var1=${var1 ? var1.varName : 'NA'}&_min_var1=${var1 ? var1[range][0] : 'NA'}&_max_var1=${var1 ? var1[range][1] : 'NA'}&_var2=${var2 ? var2.varName : 'NA'}&_min_var2=${var2 ? var2[range][0] : 'NA'}&_max_var2=${var2 ? var2[range][1] : 'NA'}&_var3=${var3 ? var3.varName : 'NA'}&_min_var3=${var3 ? var3[range][0] : 'NA'}&_max_var3=${var3 ? var3[range][1] : 'NA'}&_var4=${var4 ? var4.varName : 'NA'}&_min_var4=${var4 ? var4[range][0] : 'NA'}&_max_var4=${var4 ? var4[range][1] : 'NA'}&_var5=${var5 ? var5.varName : 'NA'}&_min_var5=${var5 ? var5[range][0] : 'NA'}&_max_var5=${var5 ? var5[range][1] : 'NA'}&_var6=${var6 ? var6.varName : 'NA'}&_min_var6=${var6 ? var6[range][0] : 'NA'}&_max_var6=${var6 ? var6[range][1] : 'NA'}&_year=${filteredYear.value}`;

    } else {
      query = `${filtersData.current.referenceDistrict.value}&_var1=${var1 ? var1.value_var : 'NA'}&_min_var1=${var1 ? var1.values[0] : 'NA'}&_max_var1=${var1 ? var1.values[1] : 'NA'}&_var2=${var2 ? var2.value_var : 'NA'}&_min_var2=${var2 ? var2.values[0] : 'NA'}&_max_var2=${var2 ? var2.values[1] : 'NA'}&_var3=${var3 ? var3.value_var : 'NA'}&_min_var3=${var3 ? var3.values[0] : 'NA'}&_max_var3=${var3 ? var3.values[1] : 'NA'}&_var4=${var4 ? var4.value_var : 'NA'}&_min_var4=${var4 ? var4.values[0] : 'NA'}&_max_var4=${var4 ? var4.values[1] : 'NA'}&_var5=${var5 ? var5.value_var : 'NA'}&_min_var5=${var5 ? var5.values[0] : 'NA'}&_max_var5=${var5 ? var5.values[1] : 'NA'}&_var6=${var6 ? var6.value_var : 'NA'}&_min_var6=${var6 ? var6.values[0] : 'NA'}&_max_var6=${var6 ? var6.values[1] : 'NA'}&_year=${filteredYear.value}`;
    }

    // Name of each variable stored on custom ranges object.
    /** TODO Remove varName key once the saved groups structure is updated */
    let vars = Object.keys(filtersData.current.vars).map(key => (filtersData.current.vars[key]['varName'] || filtersData.current.vars[key]['value_var']));

    let lbVars = vars.filter(variable => variable.split('__').length > 1);
    let tabloideVars = vars.filter(variable => variable.split('__').length === 1);
    let tabloideYears = tabloideVars.map( variable => variable + '_yr');

    let currentBoardDataRows = [];

    // Fetching grid table data.
    lbVars.forEach(lbVar => {
      let lbVariable = lbVar.split('__')[0];
      let planNum = lbVar.split('__')[1];
      let planType = lbVar.split('__')[2];

      if (filteredYear.value === 'MCD' && enabledHealthBenefits) {
        simpleFetch(`${process.env.REACT_APP_API_URL}/mcd_hb_tabloide?select=irn,district_name,${lbVariable}&${lbVariable}_yr&irn=in.(${filteredIrns})&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}`)
          .then(data => {
            let newRows = data.map((obj, key) => {
              // The variable key need change to fullname
              obj[lbVar] = obj[lbVariable];
              delete obj[lbVariable];
              return { ...obj, id: obj.irn }
            });
            let updatedRows = newRows.map((newRow) => {
              let oldRow = currentBoardDataRows.find(oldRow => oldRow.id === newRow.id);
              return oldRow ?
                { ...newRow, ...oldRow } :
                { ...newRow }
            });
            currentBoardDataRows = [...updatedRows];

            setGridTableData({
              // Process data to build rows object adding id key to data object.
              rows: currentBoardDataRows,
              // Process filters data to build columns objects with the required structure.
              columns: [{
                field: 'district_name',
                headerName: 'District',
                minWidth: 150,
                flex: 1,
              }, ...Object.keys(filtersData.current.vars).map(key => {
                let fieldBase = filtersData.current.vars[key];

                return {
                  /** TODO Remove varName key once the saved groups structure is updated */
                  field: fieldBase['value_var'] || fieldBase['varName'],
                  headerName: fieldBase['label'],
                  minWidth: 150,
                  flex: 1,
                  valueFormatter: (params) => {
                    if (typeof params.value == "number") {
                      return valueFormatted(params.value, "")
                    }
                  },
                }
              })]
            })
          });
      } else {
        simpleFetch(`${process.env.REACT_APP_API_URL}/health_insurance_readable?select=irn,district_name,${lbVariable}&irn=in.(${filteredIrns})&file_year=eq.${filteredYear.value}&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}`)
          .then(data => {
            let newRows = data.map((obj, key) => {
              // The variable key need change to fullname
              obj[lbVar] = obj[lbVariable];
              delete obj[lbVariable];
              return { ...obj, id: obj.irn }
            });
            let updatedRows = newRows.map((newRow) => {
              let oldRow = currentBoardDataRows.find(oldRow => oldRow.id === newRow.id);
              return oldRow ?
                { ...newRow, ...oldRow } :
                { ...newRow }
            });
            currentBoardDataRows = [...updatedRows];

            setGridTableData({
              // Process data to build rows object adding id key to data object.
              rows: currentBoardDataRows,
              // Process filters data to build columns objects with the required structure.
              columns: [{
                field: 'district_name',
                headerName: 'District',
                minWidth: 150,
                flex: 1,
              }, ...Object.keys(filtersData.current.vars).map(key => {
                let fieldBase = filtersData.current.vars[key];

                return {
                  /** TODO Remove varName key once the saved groups structure is updated */
                  field: fieldBase['value_var'] || fieldBase['varName'],
                  headerName: fieldBase['label'],
                  minWidth: 150,
                  flex: 1,
                  valueFormatter: (params) => {
                    if (typeof params.value == "number") {
                      return valueFormatted(params.value, "")
                    }
                  },
                }
              })]
            })
          });
      }
    });
    if (tabloideVars.length > 0) {
      if (filteredYear.value === 'MCD') {
        simpleFetch(`${process.env.REACT_APP_API_URL}/mcd_tabloide?select=irn,district_name,${tabloideVars},${tabloideYears}&irn=in.(${filteredIrns})`)
          .then(data => {
            let newRows = data.map((obj, key) => ({ ...obj, id: obj.irn }));
            let updatedRows = newRows.map((newRow) => {
              let oldRow = currentBoardDataRows.find(oldRow => oldRow.id === newRow.id);
              return oldRow ?
                { ...newRow, ...oldRow } :
                { ...newRow }
            });
            currentBoardDataRows = [...updatedRows];

            const mcdColumns = [{
              field: 'district_name',
              headerName: 'District',
              minWidth: 150,
              flex: 1,
            }]

            // Process filters data to build columns objects with the required structure.
            Object.keys(filtersData.current.vars).map(key => {
              let fieldBase = filtersData.current.vars[key];

              const mapColumn = {
                /** TODO Remove varName key once the saved groups structure is updated */
                field: fieldBase['value_var'] || fieldBase['varName'],
                headerName: fieldBase['label'],
                minWidth: 150,
                flex: 1,
                valueFormatter: (params) => {
                  /* TODO verify how to get the var_type */
                  const yearVars = ['next_contract_renewal_year', 'current_contract_year'];
                  if (typeof params.value == "number" && !yearVars.includes(params.field)) {
                    return valueFormatted(params.value, "")
                  }
                  if(yearVars.includes(params.field)) {
                    return valueFormatted(params.value, "year")
                  }
                },
              }

              mcdColumns.push(mapColumn)

              mcdColumns.push({
                field: `${mapColumn.field}_yr`,
                headerName: `${mapColumn.headerName} (Year)`
              })
              return mcdColumns
            })

            setGridTableData({
              // Process data to build rows object adding id key to data object.
              rows: currentBoardDataRows,
              columns: mcdColumns
            })
          });
      } else {
        simpleFetch(`${process.env.REACT_APP_API_URL}/hvd_tabloide?select=irn,district_name,${tabloideVars}&irn=in.(${filteredIrns})&file_year=eq.${filteredYear.value}`)
          .then(data => {
            let newRows = data.map((obj, key) => ({ ...obj, id: obj.irn }));
            let updatedRows = newRows.map((newRow) => {
              let oldRow = currentBoardDataRows.find(oldRow => oldRow.id === newRow.id);
              return oldRow ?
                { ...newRow, ...oldRow } :
                { ...newRow }
            });
            currentBoardDataRows = [...updatedRows];

            setGridTableData({
              // Process data to build rows object adding id key to data object.
              rows: currentBoardDataRows,
              // Process filters data to build columns objects with the required structure.
              columns: [{
                field: 'district_name',
                headerName: 'District',
                minWidth: 150,
                flex: 1,
              }, ...Object.keys(filtersData.current.vars).map(key => {
                let fieldBase = filtersData.current.vars[key];

                return {
                  /** TODO Remove varName key once the saved groups structure is updated */
                  field: fieldBase['value_var'] || fieldBase['varName'],
                  headerName: fieldBase['label'],
                  minWidth: 150,
                  flex: 1,
                  valueFormatter: (params) => {
                    /* TODO verify how to get the var_type */
                    const yearVars = ['next_contract_renewal_year', 'current_contract_year'];
                    if (typeof params.value == "number" && !yearVars.includes(params.field)) {
                      return valueFormatted(params.value, "")
                    }
                    if(yearVars.includes(params.field)) {
                      return valueFormatted(params.value, "year")
                    }
                  },
                }
              })]
            })
          });
      }
    }
    setParallelData(null);
    // Hook to fill yAxis for parallel chart.
    setRangeData(Object.keys(filtersData.current.vars).map(variable => {
      return {
        "min": filtersData.current.vars[variable].min_range,
        "max": filtersData.current.vars[variable].max_range,
        "higher_number": filtersData.current.vars[variable].higher_number,
      }
    }));
    // Get Parallel coordinates data.
    if(filteredIrns.length) {
      simpleFetch(`${process.env.REACT_APP_API_URL}/rpc/hvd_parallel_base_cg?_reference=${query}&_irns=${filteredIrns}`)
          .then(data => {
            setParallelData(data[0]);
          })
    }
  }

  const shareWithUsers = () => {
    if (existingGroup[0]) {
      if (shareWith.length === 0) {
        setDisplayResponseMessage(true);
        setPostResponse({
          status: "error",
          statusText: "Please select at least one user to share with"
        });
        closeShared();
      } else {
        let uuid = existingGroup[0].uuid;
        let bodyJson = existingGroup[0];

        bodyJson["available_users_share"] = shareWith;

        bodyJson = JSON.stringify(bodyJson);

        axios.put(`${process.env.REACT_APP_API_URL}/custom_groups?uuid=eq.${uuid}`, bodyJson,
          {
            headers: {
              "ngrok-skip-browser-warning": true,
              Authorization: "Bearer " + userToken,
              "Content-Type": "application/json",
            },
          }).then((response) => {
            setDisplayResponseMessage(true);
            setPostResponse({
              status: "success",
              statusText: "Shared with users successfully!"
            });
            closeShared();
          }).catch((error) => {
            setDisplayResponseMessage(true);
            setPostResponse({
              status: "error",
              statusText: error.message
            });
          });
      }
    }
  };

  // Request init data
  useEffect(() => {
    if (metadata) {
      const userSessionType = metadata.hasOwnProperty('sessionType') ? metadata.sessionType : 'forbidden';

      switch (userSessionType) {
        case 'district-access':
          window.localStorage.setItem('session-type', 'district-access');
          break;
        case 'full-access':
          window.localStorage.setItem('session-type', 'full-access');
          break;
        case 'multiple-district-access':
          window.localStorage.setItem('session-type', 'multiple-district-access');
          break;
        case 'forbidden':
          navigate("/AccessDenied", { replace: true });
          break;
        default:
          navigate("/AccessDenied", { replace: true });
          break;
      }
    } else {
      navigate("/AccessDenied", { replace: true });
    }
  }, [navigate, user, metadata]);

  useEffect(() => {
    const fetchController = new AbortController();
    if (query.get('shared')) {
      fetchData({
        endpoint: `${process.env.REACT_APP_API_URL}/custom_groups?uuid=eq.` + query.get('shared'),
        controller: fetchController
      }).then( response => {
        setExistingGroup(response.data);
        setIrns(response.data[0].custom_ranges.var1.irns)
        let groupRetrieve = response.data[0];

        if (groupRetrieve.available_users_share.some(userShare => userShare.value === user.email) || groupRetrieve.created_by === user.email) {
          if (groupRetrieve.reference_irn) {
            setReferenceDistrict(groupRetrieve.reference_irn);
            setYear(groupRetrieve.year);

            customGroupData.current = {
              name: groupRetrieve.label,
              description: groupRetrieve.description,
              vars: groupRetrieve.custom_ranges
            };
            setFilters(groupRetrieve.custom_ranges);
            setShareWith(groupRetrieve.available_users_share);
          }
        } else {
          navigate("/AccessDenied", { replace: true });
        }
      })
    }
    // Clean board if no query found and exist data.
    if (!query.get("shared")) {
      setReferenceDistrict();
      setGridTableData();
      setExistingGroup();
      setBoardData();
      setParallelData();
      setFilters()
      buildOnLoad({ user: user, callback: setBoardData, token: userToken });
    }

    // Cleaning component.
    return function cleanup() {
      fetchController?.abort("Unmounted Custom Group Dashboard");
    }
  }, [query, user, navigate, userToken]);

  useEffect(() => {
    if (usersFormat.length === 0) {
      async function getGroups() {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/groups`
        );
        return response.data;
      }

      getGroups().then(groups => {
        setUserGroups(groups);
        axios.get(`${process.env.REACT_APP_API_URL}/users`, {
          headers: {
            'ngrok-skip-browser-warning': true
          }
        })
          .then(res => {
            setUsers(res.data);

            let currentUser = res.data.find((element, index) => {
              let valid = false;

              if (element.email === user.email) {
                valid = true;
              }

              return valid;
            });

            setActiveUser(currentUser);
          });

        let filteredUsers = users.filter((userF) => userF.group_id === activeUser.group_id ? userF : false);
        let usersFormatted = filteredUsers.map((userF) => {
          let userGroup = userGroups.find(userGroup => userGroup.id === userF.group_id);
          let filteredResult = null;
          if (userF && userGroup) {
            filteredResult = { 'value': userF.email, 'label': userF.name + ' @ ' + userGroup.name };
          }
          return filteredResult;
        });
        setUsersFormat(usersFormatted);
      });
    }
  }, [activeUser.group_id, user.email, userGroups, users, usersFormat.length]);

  useEffect(() => {
    if (boardData) {
      let irnsToString = (boardData.irns).toString()
      let irnsSplit = irnsToString.split(',')
      let count = irnsSplit.length;

      setReferenceDistrict(boardData.referenceDistrict);
      setYear(boardData.year);
      setIrns(boardData.irns)
      setDistrictsCount(count)
      setGroupInfo(boardData.groupInfo);
      // if reference district or year updated, reset counter and clean chart and table data.
      if ((boardData.year.value !== year?.value) || (boardData.referenceDistrict.label !== referenceDistrict?.label) || (boardData.irns !== irns)) {
        setDistrictsCount();
        setParallelData();
        setGridTableData();
      }
    }
  }, [boardData, year?.value, referenceDistrict?.label, irns]);

  // Verify if there is nulls values on table to display footnote.
  const printNullFootnote = useMemo(() => {
    return gridTableData?.rows.some(row => Object.values(row).some(rowValue => rowValue === null));
  }, [gridTableData?.rows]);

  // Get list of Teacher Salary variable names from current filters
  const teacherSalaryVars = useMemo(() => {
    if (!filters) return [];
    return Object.values(filters)
      .filter(varData => varData?.domain_name === 'Teacher Salary' || varData?.dom === 'Teacher Salary')
      .map(varData => varData?.value_var || varData?.varName)
      .filter(Boolean);
  }, [filters]);

  // Check if any row has cross-year data for Teacher Salary variables only (for MCD mode)
  const hasCrossYearData = useMemo(() => {
    if (year?.value !== 'MCD' || !gridTableData?.rows || teacherSalaryVars.length === 0) return false;
    // Only check year columns for Teacher Salary variables
    const tsYearFields = teacherSalaryVars.map(varName => `${varName}_yr`);
    return gridTableData.rows.some(row => {
      return tsYearFields.some(field => row[field] && row[field] !== '2026' && row[field] !== 2026);
    });
  }, [gridTableData?.rows, year?.value, teacherSalaryVars]);

  // Function to highlight rows with non-current year data in MCD mode (Teacher Salary only)
  const getRowClassName = useCallback((params) => {
    if (year?.value !== 'MCD' || teacherSalaryVars.length === 0) return '';
    // Only check year columns for Teacher Salary variables
    const tsYearFields = teacherSalaryVars.map(varName => `${varName}_yr`);
    const hasOlderData = tsYearFields.some(field =>
      params.row[field] && params.row[field] !== '2026' && params.row[field] !== 2026
    );
    return hasOlderData ? 'cross-year-warning' : '';
  }, [year?.value, teacherSalaryVars]);

  const topContentElement = (
    <Box className="section--data-filters district-filters" sx={DataFiltersStyles}>
      <Grid container className={`align-container basic-filters`} spacing={0} textAlign='center' style={{ marginBottom: 20 }}>
        <Grid item xs={12} display='flex' >
          <Tooltip title="Filters">
            <Button
              id="button-filters"
              aria-controls={"menu-filters"}
              aria-haspopup="true"
              aria-expanded={openFilters ? "true" : "false"}
              variant={existingGroup ? "outlined" : "contained"}
              color={"grape"}
              disabled={!!existingGroup}
              onClick={clickFilters}
            >
              <FilterAltOutlinedIcon />
              Filters
            </Button>
          </Tooltip>
          <Menu
            id="menu-filters"
            MenuListProps={{
              'aria-labelledby': 'button-filters',
            }}
            anchorEl={btnFilter}
            open={openFilters}
            onClose={closeFilters}
            sx={MenuBoxStyles}
          >
            <MenuItem disableRipple>
              <BoardBuilder
                groupEnabled={true}
                yearEnabled={true}
                boardData={setBoardData}
                onSubmit={() => handleFilter()}
              />
            </MenuItem>
          </Menu>
          <Tooltip title="Save Board">
            <span>
              <Button
                id="button-saved"
                aria-controls={openSaved ? 'menu-saved' : undefined}
                aria-haspopup="true"
                aria-expanded={openSaved ? 'true' : undefined}
                variant="outlined"
                color="grape"
                disabled={
                  !gridTableData ? true : // if
                    !!existingGroup  // else
                }
                onClick={clickSaved}
              >
                <SaveOutlinedIcon />
              </Button>
            </span>
          </Tooltip>
          <Menu
            id="menu-saved"
            MenuListProps={{
              'aria-labelledby': 'button-saved',
            }}
            anchorEl={btnSaved}
            open={openSaved}
            onClose={closeSaved}
            sx={MenuBoxStyles}
          >
            <MenuItem disableRipple sx={{ minWidth: "230px" }} className="save-group-form">
              <form className={`save-group-form__wrapper`} onSubmit={handleSubmit}>
                <Grid container spacing={2} className="custom-groups__form-wrapper">
                  {!action &&
                    <Button sx={{ margin: "20px 0px 10px 30px" }} variant="contained" color="grape" onClick={() => !existingGroup ? setAction('new-group') : navigate('/custom-groups')} type="submit">
                      {!existingGroup ? 'Save Custom Group' : 'Save a New Custom Group'}
                    </Button>
                  }
                  {action === 'new-group' &&
                    <>
                      <Grid item xs={12} sm={12} className="custom-groups__form-item doneButton">
                        <TextField
                          autoComplete='off'
                          className='form-field form-field--group-name'
                          id="GroupName"
                          fullWidth
                          variant="outlined"
                          placeholder="Group Name"
                          required
                          onChange={e => groupName.current = e.target.value.trim()}
                          sx={InputEditStyles}
                          inputProps={{
                            minLength: 3,
                            pattern: "^[^\\s](?:(?!\\s{2,}).)*[^\\s]$",
                            title: "Group name must start and end with a letter or number, and can't contain consecutive spaces"
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} className="custom-groups__form-item doneButton">
                        <TextField
                          autoComplete='off'
                          className='form-field form-field--group-name'
                          id="GroupDescription"
                          fullWidth
                          variant="outlined"
                          placeholder="Group Description"
                          onChange={e => groupDescription.current = e.target.value.trim()}
                          sx={InputEditStyles}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} className="custom-groups__form-item doneButton">
                        <Button variant="contained" color="grape" type="submit">
                          Save
                        </Button>
                      </Grid>
                    </>
                  }
                </Grid>
              </form>
            </MenuItem>
          </Menu>
          {(existingGroup && enabledShare) &&
            <>
              <Tooltip title="Share Board">
                <span>
                  <Button
                    id="button-shared"
                    aria-controls={"menu-shared"}
                    aria-haspopup="true"
                    aria-expanded={openShared ? "true" : "false"}
                    variant="outlined"
                    color="grape"
                    disabled={!!(existingGroup && existingGroup[0].created_by !== user.email)}
                    onClick={clickShared}
                  >
                    <ShareOutlinedIcon />
                  </Button>
                </span>
              </Tooltip>
              <Menu
                id="menu-shared"
                MenuListProps={{
                  'aria-labelledby': 'button-shared',
                }}
                anchorEl={btnShared}
                open={openShared}
                onClose={closeShared}
                sx={MenuBoxStyles}
              >
                <MenuItem disableRipple>
                  {usersFormat &&
                    <Grid container spacing={2} textAlign='center' >
                      <Grid item sm={12} display='flex' >
                        <Autocomplete
                          sx={{
                            '& .MuiAutocomplete-tag': {
                              backgroundColor: '#808080',
                              color: "#ffffff"
                            },
                          }}
                          multiple
                          fullWidth
                          noOptionsText={'Loading...'}
                          options={usersFormat}
                          id={"shared-with"}
                          defaultValue={shareWith}
                          onChange={(e, newValue) => {
                            setShareWith(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} />
                          )}
                        />
                      </Grid>
                      <Grid item sm={12} display='flex' >
                        <Button variant="contained" color="grape" onClick={() => shareWithUsers()}>
                          Share with users
                        </Button>
                      </Grid>
                    </Grid>}
                </MenuItem>
              </Menu>
            </>
          }
        </Grid>
      </Grid>
      <div className="group-counter__wrapper">
        <Box className="group-counter" textAlign={"center"}>
          {(referenceDistrict && groupInfo) && (
            <div className="group-counter__versus">{`${referenceDistrict.label} - vs -`} <GroupDisplay groupData={{groupInfo: groupInfo, groupType: boardData?.groupType}}/></div>
          )}
          {(districtsCount && referenceDistrict && year) && (
            <div className="group-counter__result">{`Year: ${year.value === "MCD"
                ? `2026 (${year.label})`
                : year.label} | ${districtsCount} districts in the comparison group.`}</div>
          )}
          {existingGroup && (
            <>
              <div className="group-counter__result">
                { existingGroup[0].label}
                { existingGroup[0].description && '- ' + existingGroup[0].description}
              </div>
              <div>Saved custom groups are read-only.</div>
            </>
          )}
        </Box>
      </div>
    </Box>

  );

  return (
    <LayoutPage
      pageTitle="Custom Group Editor"
      description="Build custom groups based on filters"
      type="dashboard"
      customClass="custom-groups"
      topContent={topContentElement}
    >
      <Box sx={CustomGroupStyles}>
        <section className="custom-groups__filters-form">
          <Grid container spacing={2}>
            {
              (referenceDistrict && year && irns) &&
                 <Grid className="custom-groups__filters" item xs={12}>
                  <MultiVariableFilter
                    year={year}
                    referenceDistrict={referenceDistrict}
                    disabled={!!existingGroup}
                    onApply={getFiltersInformation}
                    initData={filters}
                    irns={irns}
                  />
                </Grid>
            }
          </Grid>
        </section>
        {parallelData && (
          <div className="parallel-chart">
            <ParallelChart
              data={parallelData}
              rangeData={rangeData}
              referenceDistrictId={referenceDistrict.value}
            />
          </div>
        )}
        { gridTableData && (
          <section className="custom-groups__data-table">
            <p>
              <InfoOutlinedIcon className="custom-groups__info-icon"/>
              <strong>
               The filter at the table has an effect only on the table output, not the custom group.
              </strong>
            </p>
            <DataGridTable
              columns={gridTableData.columns.map((item) => ({
                ...item,
                align: item.field !== "district_name" ? "center" : "left",
                headerAlign: item.field !== "district_name" ? "center" : "left"
              }))}
              rows={gridTableData.rows}
              getRowClassName={getRowClassName}
            />
            { hasCrossYearData && (
                <div className="cross-year-note"><strong>Note:</strong> <span className="cross-year-indicator"></span> Highlighted rows contain Teacher Salary data from a prior year (not 2026). Cross-year salary comparisons may not be directly comparable.</div>
            )}
            { printNullFootnote && (
                <div><strong key="null_message">Note:</strong> 'No Data' values in districts indicate the absence of data for the selected year.</div>
            )}
          </section>
        )}
      </Box>

      <ReportButtons
        boardType={"Board Insight Groups"}
        collectedData={{
          referenceDistrict: referenceDistrict,
          label: customGroupData.current.name,
          description: customGroupData.current.description,
          custom_ranges: customGroupData.current.vars,
        }}
      />
      <Snackbar
        sx={SnackbarStyles}
        className="custom-groups__save-message"
        open={displayResponseMessage}
        autoHideDuration={6000}
        onClose={() => setDisplayResponseMessage(false)}
      >
        <Alert onClose={() => setDisplayResponseMessage(false)} variant="filled" severity={`${postResponse?.status ?? 'success'}`}>{postResponse?.statusText}</Alert>
      </Snackbar>
    </LayoutPage>
  );
}

export default CustomGroupEditor;
